import React from "react";
import { ArrowRight, Activity, Brain, HeartPulse, Sprout } from "lucide-react";
import { HERO_IMAGE, PILLARS } from "../mock";

const iconMap = { Activity, Brain, HeartPulse, Sprout };

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Tatva Wellness Center — family wellness and yoga in nature"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#fbf9f4]/40 via-[#fbf9f4]/55 to-[#fbf9f4]/85" />
        <div className="absolute inset-0 bg-[#fbf9f4]/25" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 pt-24 pb-12 max-w-5xl mx-auto">
        <p className="font-serif italic text-[#1b5e3a] text-lg md:text-xl mb-4 opacity-90 animate-[fadeInUp_0.9s_ease-out]">
          Tatva Wellness Center
        </p>

        <h1 className="font-serif text-[54px] sm:text-[80px] md:text-[104px] leading-[0.95] tracking-tight text-[#1b5e3a] drop-shadow-[0_2px_10px_rgba(255,255,255,0.5)] animate-[fadeInUp_1s_ease-out_0.1s_both]">
          Reconnect.
          <br />
          <span className="italic text-[#2c7a4a]">Rebalance.</span>
          <br />
          Rediscover You.
        </h1>

        <div className="flex items-center justify-center gap-4 my-8 animate-[fadeInUp_1s_ease-out_0.2s_both]">
          <span className="h-px w-16 bg-[#c4a257]" />
          <Sprout className="w-5 h-5 text-[#c4a257]" />
          <span className="h-px w-16 bg-[#c4a257]" />
        </div>

        <button
          onClick={() => scrollTo("#treatments")}
          className="group inline-flex items-center gap-3 bg-[#1b5e3a] hover:bg-[#164d30] text-white text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 rounded-md shadow-[0_10px_30px_rgba(27,94,58,0.35)] hover:shadow-[0_14px_40px_rgba(27,94,58,0.5)] transition-all duration-300 hover:-translate-y-0.5 animate-[fadeInUp_1s_ease-out_0.3s_both]"
        >
          Explore Treatments
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </button>

        {/* Pillars */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 max-w-3xl mx-auto animate-[fadeInUp_1s_ease-out_0.45s_both]">
          {PILLARS.map((p, i) => {
            const Icon = iconMap[p.icon];
            return (
              <div
                key={p.title}
                className="relative flex flex-col items-center text-center px-4"
              >
                {i > 0 && (
                  <span className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 h-10 w-px bg-[#c4a257]/40" />
                )}
                <Icon className="w-9 h-9 text-[#1b5e3a] mb-2" strokeWidth={1.4} />
                <p className="font-serif text-[#1b5e3a] text-lg md:text-xl">{p.title}</p>
                <p className="text-[11px] md:text-xs text-[#3a4a3d] mt-1 opacity-80">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
